import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MiscService } from 'app/shared/misc.service';
import { environment } from 'environments/environment';
import { map, retry, tap } from 'rxjs/operators';
import { AuthHeaderService } from 'app/shared/auth-header.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StaffService {
  constructor(
    private http: HttpClient,
    private authHeaderService: AuthHeaderService,
  ) { }

  createStaff = (requestBody) => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader(requestBody);
    const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

    return this.http.post(`${environment.API_URL2}/xas/v1/external/staff/createSingleStaffPayroll`, requestBody, { headers }).pipe(retry(3));
  }


    updateBulkStaffs(payloads: any[], merchantId: string): Observable<any> {
    const xAuthHeader = this.authHeaderService.generateAuthHeader(payloads);
    const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

    return this.http.patch(`${environment.API_URL2}/xas/v1/external/staff/bulkStaffUpdate/${merchantId}`, payloads, { headers }).pipe(retry(3));
  }

  
  addStaffAccount(payload): Observable<any> {
 const xAuthHeader = this.authHeaderService.generateAuthHeader(payload);
    const headers = new HttpHeaders()
    .set('X-Auth-Signature', xAuthHeader)
    .set('X-APP-ID', `${environment.X_APP_ID}`)
    .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

  const url = `${environment.API_URL2}/xas/v1/external/staff/addStaffAccount`; // Replace baseUrl with your actual API base URL
  
  return this.http.post(url, payload, { headers });
}

deleteStaffAccount(
  staffId: string, 
 
  merchantId: string, 
  accountNumber: string
): Observable<any> {

   const xAuthHeader = this.authHeaderService.generateAuthHeader({});
    const headers = new HttpHeaders()
    .set('X-Auth-Signature', xAuthHeader)
    .set('X-APP-ID', `${environment.X_APP_ID}`)
    .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);
  const url = `${environment.API_URL2}/xas/v1/external/staff/deleteStaffAccount/${staffId}/${merchantId}/${accountNumber}`;
  
  
  return this.http.delete<any>(url,{ headers }).pipe();
}

// Method to update staff account
updateStaffAccount(staffId: string, staffCode: string, merchantId: string, accountId: string, payload: any): Observable<any> {
   const xAuthHeader = this.authHeaderService.generateAuthHeader(payload);
  const headers = new HttpHeaders()
    .set('X-Auth-Signature', xAuthHeader)
    .set('X-APP-ID', `${environment.X_APP_ID}`)
    .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

  const url = `${environment.API_URL2}/xas/v1/external/staff/updateStaffAccount/${staffId}/${staffCode}/${merchantId}/${accountId}`;
  
  return this.http.patch(url, payload, { headers });
}
  createBulkStaffs = (requestBody: any[]): Observable<any> => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader(requestBody);
    const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

    return this.http.post(`${environment.API_URL2}/xas/v1/external/staff/bulkPayroll`, requestBody, { headers }).pipe(retry(3));
  }

  getUserDetailsByWalletNumber = (wallet_number: any, scheme_code: string): Observable<any> => {
    return this.http.get(`${environment.API_URL}/source/details/${wallet_number}/${scheme_code}`).pipe(retry(3));
  }

  fetchMerchantFwpHistory = (merchant_id: string, skip: any, limit: any, active: string, paid: string): Observable<any> => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader({});
    const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);
    let url = `${environment.API_URL2}/xas/v1/external/fwp-loan/history/merchant-v2/${merchant_id}?skip=${skip}&limit=${limit}&includeStaff=true`
    if (active == 'active') {
      url += `&active=true`
    }
    if (active == 'expired') {
      url += `&active=false`
    }
    if (paid == 'paid') {
      url += `&paid=true`
    }
    if (paid == 'unpaid') {
      url += `&paid=false`
    }
    return this.http.get(`${url}`, { headers }).pipe(retry(3));
  }

  fetchLoansAnalytics = (merchant_id: string, startDate: string, endDate: string): Observable<any> => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader({});
    const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

    let url = `${environment.API_URL2}/xas/v1/external/fwp-loan/analytics/merchant/${merchant_id}`;

    if (startDate !== '' && endDate !== '') {
      url += `?startDate=${startDate}&endDate=${endDate}`;
    }

    return this.http.get(url, { headers }).pipe(retry(3));
  }


  fetchStaffFwpHistory = (staff_id: string): Observable<any> => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader({});
    const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

    return this.http.get(`${environment.API_URL2}/xas/v1/external/fwp-loan/history/staff/${staff_id}`, { headers }).pipe(retry(3));
  }

  updateStaff = (requestBody: any, staffId: string) => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader(requestBody);
    const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

    return this.http.put(`${environment.API_URL2}/xas/v1/external/staff/${staffId}`, requestBody, { headers }).pipe(retry(3));
  }

  actiuvateStaff = (requestBody: any, staffId: string): Observable<any> => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader(requestBody);
    const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

    return this.http.put(`${environment.API_URL2}/xas/v1/external/staff/${staffId}`, requestBody, { headers }).pipe(retry(3));
  }

  fetchStaffs = (id: string, skip?: any, limit?: any, filter?: string, search?: string) => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader({});
    const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);
    let url = `${environment.API_URL2}/xas/v1/external/staff/merchant/${id}?skip=${skip}&limit=${limit}&filter=${filter}`;
    if (search) {
      url += `&search=${search}`;
    }
    return this.http.get(`${url}`, { headers }).pipe(retry(3));
  }

  fetchStaff = (merchantId: string, staffId: string) => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader({});
    const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

    return this.http.get(`${environment.API_URL2}/xas/v1/external/staff/${merchantId}/${staffId}`, { headers }).pipe(retry(3));
  }


  
  createStaffEndOfMonthPayroll = (merchant_id: string, merchant_code: string) => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader({});
    const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

    return this.http.get(`${environment.API_URL2}/xas/v1/external/staff/merchant/end-of-month-payroll/${merchant_id}/${merchant_code}`, { headers }).pipe(retry(3));
  }

  deactivateStaff = (merchantId: string, staffId: string): Observable<any> => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader({});
    const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

    return this.http.delete(`${environment.API_URL2}/xas/v1/external/staff/${merchantId}/${staffId}`, { headers }).pipe(retry(3));
  }

  createLoanSetup(payload: any): Observable<any> {
    const xAuthHeader = this.authHeaderService.generateAuthHeader(payload);
    const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

    return this.http.post(`${environment.API_URL2}/xas/v1/external/fwp-loan/setup`, payload, { headers }).pipe(retry(3));
  }

  getLoanSetup(merchantId: string): Observable<any> {
    const xAuthHeader = this.authHeaderService.generateAuthHeader({});
    const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);

    return this.http.get(`${environment.API_URL2}/xas/v1/external/fwp-loan/setup/${merchantId}`, { headers }).pipe(retry(3));
  }

  updateLoanSetup(payload: any, id: string): Observable<any> {
    const xAuthHeader = this.authHeaderService.generateAuthHeader(payload);
    const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`)

    return this.http.put(`${environment.API_URL2}/xas/v1/external/fwp-loan/setup/${id}`, payload, { headers }).pipe(retry(3));
  }

  settleLoan(merchantId: string): Observable<any> {
    const xAuthHeader = this.authHeaderService.generateAuthHeader({});
    const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`)

    return this.http.put(`${environment.API_URL2}/xas/v1/external/fwp-loan/repayment/${merchantId}`, {}, { headers }).pipe(retry(1));
  }


  // https://api.xcelapp.com/xas/v1/external/fwp-loan/history/merchant-v2/64a84dbef9a0c6001a3848b8/download?skip=0&limit=50&includeStaff=true
  downloadFwpHistory = (merchantId: string, skip: any, limit: any, active: string, paid: string) => {
    const xAuthHeader = this.authHeaderService.generateAuthHeader({});
    const headers = new HttpHeaders()
      .set('X-Auth-Signature', xAuthHeader)
      .set('X-APP-ID', `${environment.X_APP_ID}`)
      .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);
    let url = `${environment.API_URL2}/xas/v1/external/fwp-loan/history/merchant-v2/${merchantId}/download?skip=${skip}&limit=${limit}&includeStaff=true`
    if (active == 'active') {
      url += `&active=true`
    }
    if (active == 'expired') {
      url += `&active=false`
    }
    if (paid == 'paid') {
      url += `&paid=true`
    }
    if (paid == 'unpaid') {
      url += `&paid=false`
    }
    return this.http.get(`${url}`, { headers, responseType: 'blob' as 'json' }).pipe(retry(3));
  }

}
